module.exports = __webpack_public_path__ + "img/t2-14.00d1ee7b.svg";